import { createContext } from 'react';
import { Logger } from '../utils/logger';

export interface LoggerContextType {
  logger: Logger;
}

export const LoggerContext = createContext<LoggerContextType | undefined>(
  undefined
);
